module.exports = __webpack_public_path__ + "media/images/vsaas_white-f454062cc31ab791f9716083a4998020.png";